import { NgModule, CUSTOM_ELEMENTS_SCHEMA }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';

import {FontAwesomeModule, FaIconLibrary} from '@fortawesome/angular-fontawesome';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import {IsAuthenticatedAuthGuard} from './auth-guards/is-authenticated-auth-guard';
import {provideRouter, Router, withComponentInputBinding} from '@angular/router';
import {AuthService} from './services/auth.service';
import {AuthInterceptorService} from './services/auth-interceptor.service';
import {MomentModule} from 'ngx-moment';
import { CodeInputModule } from '@fastenhealth/angular-code-input';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { AuthSigninComponent } from './pages/auth-signin/auth-signin.component';
import { VaultSigninCodeComponent } from './pages/vault-signin-code/vault-signin-code.component';
import { ConnectedAppsTabComponent } from './components/connected-apps-tab/connected-apps-tab.component';
import { ConnectedAccountsTabComponent } from './components/connected-accounts-tab/connected-accounts-tab.component';
import { SettingsTabComponent } from './components/settings-tab/settings-tab.component';
import {IdentityVerificationComponent} from "./pages/identity-verification/identity-verification.component";
import {
  IdentityVerificationErrorComponent
} from "./pages/identity-verification-error/identity-verification-error.component";
import {LoggerModule, NgxLoggerLevel} from "ngx-logger";
import {routes} from "./app-routing.module";
import {
  HealthSystemBrandDetailsComponent
} from "./pages/health-system-brand-details/health-system-brand-details.component";
import {HealthSystemConnectingComponent} from "./pages/health-system-connecting/health-system-connecting.component";
import {HealthSystemSearchComponent} from "./pages/health-system-search/health-system-search.component";
import {ImageFallbackDirective, SafeHtmlPipe, StateNamePipe} from "@shared-library";
import {AccountDetailsComponent} from "./pages/account-details/account-details.component";
import {AccountExportModalComponent} from "./components/account-export-modal/account-export-modal.component";
import {TestModeRedirectComponent} from './pages/test-mode-redirect/test-mode-redirect.component';
import {FormSupportRequestComponent} from './pages/form-support-request/form-support-request.component';
import {AuthCallbackComponent} from './pages/auth-callback/auth-callback.component';

@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent,
        SpinnerComponent,
        AuthSigninComponent,
        AuthCallbackComponent,
        VaultSigninCodeComponent,
        IdentityVerificationComponent,
        IdentityVerificationErrorComponent,
        ConnectedAppsTabComponent,
        ConnectedAccountsTabComponent,
        SettingsTabComponent,
        HealthSystemBrandDetailsComponent,
        HealthSystemConnectingComponent,
        HealthSystemSearchComponent,
        AccountDetailsComponent,
        AccountExportModalComponent,
        TestModeRedirectComponent,
        FormSupportRequestComponent,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        AppRoutingModule,
        FontAwesomeModule,
        MomentModule,
        CodeInputModule,
        InfiniteScrollModule,
        SafeHtmlPipe,
        StateNamePipe,
        ImageFallbackDirective,
        LoggerModule.forRoot({
          level: NgxLoggerLevel.DEBUG,
          context: 'vault',
        }),
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
            // deps: [AuthService, Router]
        },
        IsAuthenticatedAuthGuard,
        provideHttpClient(withInterceptorsFromDi()),
        provideRouter(routes, withComponentInputBinding())
    ]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far);
  }
}
